/* eslint-disable sort-keys */

import React from 'react'
import Action from './action'

const actionColumn = {
  key: 'action',
  render: category => {
    const action = <Action category={category} />
    return action
  },
  title: 'Actions',
  width: 150
}

const nameColumn = {
  dataIndex: 'name',
  key: 'name',
  sorter: (a, b) => a.name.localeCompare(b.name),
  title: 'Category Name',
  width: 300
}

const introductionColumn = {
  dataIndex: 'introduction',
  key: 'introduction',
  title: 'Category Introduction',
  width: 700
}

const createdColumn = {
  dataIndex: 'created',
  key: 'created',
  sorter: (a, b) => a.created > b.created,
  title: 'Category Created',
  width: 200
}

export const categoryColumns = {
  action: actionColumn,
  name: nameColumn,
  introduction: introductionColumn,
  created: createdColumn
}
